import {
    CLEAN_FORM,
    SET_STATE_FORM,
    UPDATE_FIELD_FILTER,
    SET_MASK,
    SET_ORDER,
    RECEIVE_DATA,
    UPDATE_TABLE_COLUMN,
    ERROR_V_LIST,
    RECEIVE_V_LIST,
    REQUEST_V_LIST,
    RECEIVE_V_LIST2,
    UPDATE_FIELD_ENTITY,
    CHANGE_IMAGE,
    SET_SELECTED_ROW,
    SHOW_POPUP,
    HIDE_POPUP,
    ADD_VENDEDOR
} from "./types";

const initialState = {
    formState: "search",
    loading: false,
    openPopup: false,
    entity: {
        comentario: "",
        tag: "",
        name: [],
        archivoId: 0,
        nombre: "",
    },
    form: {
        imagen: "",
        archivo: "",
    },
    errors: {
        codigo: "",
        usuario: "",
        documentoIdentidad: "",
    },
    filters: {
        distribuidorId: 0,
        dDistribuidor: "",
        categoriaArchivoId: 0,
        dCategoriaArchivo: "",
        tipoId: 0,
        dTipo: "",
        nombre: "",
        fechaLimite: false,
        band: false,
        hasta: new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate()),
        comentario: "",
        codigo: "",
        codigoLista: 0,
        compartir: false,
        valor: "",
        notificar: false,
        vendedor: "",
    },
    store: {
        loading: false,
        pageSize: 50,
        start: 0,
        total: 0,
        data: [],
        selected: [],
        detalle: [],
        //col : ['Nit_Ruc','CodigoCliente','Cliente','CodigoProducto','Producto','PrecioEspecial','PrecioMinimo','Descuento','Cantidad']
        //source: null
        subida: [],
        band: false,
    },
    clean: {
        limpiador: false,
    },
    stored: {
        loading: false,
        pageSize: 50,
        start: 0,
        total: 0,
        data: [],
        selected: [],
        //source: null
    },
    table: {
        order: "asc",
        orderBy: "",
        columns: [
            { dataKey: "categoria", label: "Categoria", width: 90 },
            { dataKey: "nombreCompleto", label: "Nombre", width: 200 },
            { dataKey: "descripcion", label: "Descripcion", width: 200 },
            { dataKey: "tipo", label: "Tipo", width: 90 },
            { dataKey: "uri", label: "Enlace", width: 350 },
            { dataKey: "tag", label: "Tag", width: 90 },
            { dataKey: "hasta", label: "Hasta", width: 90 },
        ],
    },
    tablexport: {
        order: "asc",
        orderBy: "",
        columns: [
            { dataKey: "categoria", label: "Categoria", width: 90 },
            { dataKey: "descripcion", label: "Descripcion", width: 200 },
            { dataKey: "nombreCompleto", label: "Nombre", width: 200 },
            { dataKey: "tipo", label: "Tipo", width: 90 },
            { dataKey: "tag", label: "Tag", width: 90 },
            { dataKey: "uri", label: "Enlace", width: 350 },
            { dataKey: "hasta", label: "Hasta", width: 90 },
        ],
    },
};

export const cargarmiespacioReducer = (state, action) => {
    state = state || initialState;

    switch (action.type) {
        case CLEAN_FORM:
            return {
                ...state,
                entity: initialState.entity,
                filters: initialState.filters,
                errors: initialState.errors,
                store: initialState.store,
                clean: {
                    ...state.clean,
                    limpiador: true,
                },
            };
        case SET_STATE_FORM:
            return {
                ...state,
                formState: action.formState,
            };
        case SET_SELECTED_ROW:
            return {
                ...state,
                store: {
                    ...state.store,
                    selected: action.selected,
                },
            };
        case CHANGE_IMAGE:
            return {
                ...state,
                form: {
                    ...state.form,
                    archivo: action.file,
                    imagen: action.image,
                },
            };
        case UPDATE_FIELD_ENTITY:
            return {
                ...state,
                entity: {
                    ...state.entity,
                    [action.key]: action.value,
                },
            };

        case UPDATE_FIELD_FILTER:
            return {
                ...state,
                filters: {
                    ...state.filters,
                    [action.key]: action.value,
                },
            };
        case ERROR_V_LIST:
            return {
                ...state,
                store: {
                    ...state.store,
                    loading: false,
                },
            };
        case RECEIVE_V_LIST:
            return {
                ...state,
                store: {
                    ...state.store,
                    loading: false,
                    total: action.total,
                    data: action.payload,
                    source: null,
                },
            };

        case RECEIVE_V_LIST2:
            return {
                ...state,
                stored: {
                    ...state.store,
                    loading: false,
                    total: action.total,
                    data: action.payload,
                    source: null,
                },
            };

        case REQUEST_V_LIST:
            return {
                ...state,
                store: {
                    ...state.store,
                    loading: false,
                    source: action.source,
                },
            };
        case RECEIVE_DATA:
            return {
                ...state,
                data: action.payload,
                store: {
                    ...state.store,
                    data: action.storeData,
                },
            };
        case ADD_VENDEDOR:
            console.log(action.payload)
            return {
                ...state,
                filters: {
                    ...state.filters,
                    vendedor: action.payload
                }
            };
        case UPDATE_TABLE_COLUMN:
            return {
                ...state,
                table: {
                    ...state.table,
                    columns: action.columns,
                },
            };
        case SET_MASK:
            return {
                ...state,
                loading: action.loading,
            };
        case SHOW_POPUP:
            return {
                ...state,
                openPopup: true,
            };
        case HIDE_POPUP:
            return {
                ...state,
                openPopup: false,
            };

        case SET_ORDER:
            return {
                ...state,
                table: {
                    ...state.table,
                    order: action.order,
                    orderBy: action.orderBy,
                },
            };

        default:
            return state;
    }
};
